import { render } from "./brokerages.vue?vue&type=template&id=87c4abe4"
import script from "./brokerages.vue?vue&type=script&lang=js"
export * from "./brokerages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__